var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndriodDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 45,
    viewBox: "0 0 150 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.07031,
    y: 1.00244,
    width: 147.5,
    height: 43,
    rx: 4.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.52 24.4288C72.9328 24.4288 70.824 26.3967 70.824 29.1071C70.824 31.801 72.9328 33.7854 75.52 33.7854C78.1083 33.7854 80.217 31.801 80.217 29.1071C80.2159 26.3967 78.1072 24.4288 75.52 24.4288ZM75.52 31.944C74.1021 31.944 72.88 30.7747 72.88 29.1082C72.88 27.4241 74.1032 26.2724 75.52 26.2724C76.9379 26.2724 78.16 27.4241 78.16 29.1082C78.16 30.7736 76.9379 31.944 75.52 31.944ZM65.2746 24.4288C62.6874 24.4288 60.5787 26.3967 60.5787 29.1071C60.5787 31.801 62.6874 33.7854 65.2746 33.7854C67.8629 33.7854 69.9716 31.801 69.9716 29.1071C69.9716 26.3967 67.8629 24.4288 65.2746 24.4288ZM65.2746 31.944C63.8567 31.944 62.6346 30.7747 62.6346 29.1082C62.6346 27.4241 63.8578 26.2724 65.2746 26.2724C66.6925 26.2724 67.9146 27.4241 67.9146 29.1082C67.9157 30.7736 66.6925 31.944 65.2746 31.944ZM53.0888 25.8654V27.8498H57.8386C57.6967 28.9663 57.3249 29.7814 56.7573 30.3479C56.0665 31.0387 54.9852 31.801 53.0888 31.801C50.165 31.801 47.8792 29.4437 47.8792 26.5199C47.8792 23.5961 50.165 21.2388 53.0888 21.2388C54.6662 21.2388 55.8179 21.8592 56.6682 22.6567L58.0685 21.2564C56.8805 20.1223 55.3042 19.2544 53.0888 19.2544C49.0837 19.2544 45.7166 22.5148 45.7166 26.5199C45.7166 30.525 49.0837 33.7854 53.0888 33.7854C55.2503 33.7854 56.8816 33.0759 58.1565 31.7471C59.4677 30.4359 59.8758 28.5923 59.8758 27.104C59.8758 26.6442 59.8406 26.2185 59.7691 25.8643H53.0888V25.8654ZM102.928 27.4065C102.538 26.3615 101.35 24.4288 98.9225 24.4288C96.5124 24.4288 94.5093 26.3252 94.5093 29.1071C94.5093 31.7295 96.4948 33.7854 99.1524 33.7854C101.296 33.7854 102.537 32.4742 103.052 31.7119L101.457 30.6482C100.926 31.4281 100.198 31.9418 99.1524 31.9418C98.1074 31.9418 97.3627 31.4633 96.8842 30.5239L103.14 27.9367L102.928 27.4065ZM96.5476 28.9663C96.4948 27.1579 97.9479 26.2372 98.994 26.2372C99.8091 26.2372 100.5 26.6453 100.731 27.2294L96.5476 28.9663ZM91.4622 33.5027H93.5171V19.7516H91.4622V33.5027ZM88.0941 25.4749H88.0237C87.5628 24.9249 86.6762 24.4288 85.5608 24.4288C83.2211 24.4288 81.0772 26.4847 81.0772 29.1258C81.0772 31.7482 83.2211 33.7865 85.5608 33.7865C86.6773 33.7865 87.5628 33.2904 88.0237 32.7239H88.0941V33.3971C88.0941 35.1868 87.1371 36.1438 85.596 36.1438C84.3376 36.1438 83.5577 35.2407 83.2387 34.4784L81.449 35.2231C81.9627 36.4628 83.3267 37.9874 85.596 37.9874C88.0061 37.9874 90.0443 36.5695 90.0443 33.1133V24.7137H88.0952V25.4749H88.0941ZM85.7379 31.944C84.32 31.944 83.1331 30.756 83.1331 29.1258C83.1331 27.4769 84.32 26.2724 85.7379 26.2724C87.1371 26.2724 88.236 27.4769 88.236 29.1258C88.236 30.756 87.1371 31.944 85.7379 31.944ZM112.557 19.7516H107.639V33.5027H109.69V28.2931H112.556C114.831 28.2931 117.068 26.6464 117.068 24.0229C117.068 21.3994 114.832 19.7516 112.557 19.7516ZM112.61 26.3791H109.69V21.6656H112.61C114.144 21.6656 115.015 22.9361 115.015 24.0229C115.015 25.0877 114.144 26.3791 112.61 26.3791ZM125.295 24.4046C123.809 24.4046 122.27 25.0591 121.633 26.51L123.455 27.2701C123.844 26.51 124.57 26.2614 125.33 26.2614C126.392 26.2614 127.471 26.8983 127.488 28.0302V28.1721C127.117 27.9598 126.32 27.6419 125.348 27.6419C123.384 27.6419 121.384 28.721 121.384 30.7373C121.384 32.5776 122.995 33.7623 124.799 33.7623C126.178 33.7623 126.939 33.143 127.417 32.417H127.487V33.4785H129.469V28.2062C129.471 25.7664 127.647 24.4046 125.295 24.4046ZM125.046 31.9407C124.375 31.9407 123.437 31.6041 123.437 30.7725C123.437 29.711 124.605 29.304 125.614 29.304C126.515 29.304 126.941 29.4987 127.488 29.7638C127.329 31.0387 126.232 31.9407 125.046 31.9407ZM136.688 24.7049L134.335 30.6669H134.264L131.822 24.7049H129.611L133.273 33.0374L131.185 37.6728H133.326L138.97 24.7049H136.688ZM118.201 33.5027H120.253V19.7516H118.201V33.5027Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7302 11.7697C52.7302 12.6915 52.4574 13.4252 51.9107 13.973C51.2903 14.6242 50.4807 14.9498 49.4863 14.9498C48.5337 14.9498 47.723 14.6198 47.0575 13.9598C46.3909 13.2987 46.0576 12.4803 46.0576 11.5035C46.0576 10.5256 46.3909 9.7072 47.0575 9.0472C47.723 8.3861 48.5337 8.0561 49.4863 8.0561C49.9593 8.0561 50.4114 8.1485 50.8404 8.3322C51.2705 8.517 51.6148 8.7623 51.8722 9.0692L51.2925 9.65C50.8558 9.1275 50.2541 8.8668 49.4852 8.8668C48.79 8.8668 48.1894 9.111 47.6823 9.5994C47.1752 10.0878 46.9222 10.7225 46.9222 11.5024C46.9222 12.2823 47.1752 12.917 47.6823 13.4054C48.1894 13.8938 48.79 14.138 49.4852 14.138C50.2222 14.138 50.8371 13.8927 51.3288 13.401C51.6478 13.0809 51.8326 12.6354 51.8821 12.0645H49.4852V11.2714H52.6829C52.7159 11.4441 52.7302 11.6102 52.7302 11.7697Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8013 9.01317H54.7961V11.1054H57.5065V11.8985H54.7961V13.9907H57.8013V14.8025H53.948V8.20247H57.8013V9.01317Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3773 14.8025H60.5292V9.01317H58.6856V8.20247H63.2209V9.01317H61.3773V14.8025Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5022 14.8025V8.20247H67.3502V14.8025H66.5022Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1113 14.8025H70.2632V9.01317H68.4196V8.20247H72.9549V9.01317H71.1113V14.8025Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5402 13.95C80.8912 14.6166 80.0849 14.9499 79.1202 14.9499C78.1555 14.9499 77.3492 14.6166 76.7013 13.95C76.0523 13.2834 75.7289 12.4672 75.7289 11.5025C75.7289 10.5378 76.0523 9.72155 76.7013 9.05495C77.3492 8.38835 78.1555 8.05396 79.1202 8.05396C80.0794 8.05396 80.8846 8.38945 81.5358 9.05935C82.187 9.72925 82.5126 10.5433 82.5126 11.5025C82.5126 12.4672 82.1881 13.2834 81.5402 13.95ZM77.3272 13.3967C77.8156 13.8917 78.4129 14.1381 79.1202 14.1381C79.8275 14.1381 80.4259 13.8906 80.9132 13.3967C81.4016 12.9017 81.6469 12.2703 81.6469 11.5025C81.6469 10.7347 81.4016 10.1033 80.9132 9.60826C80.4259 9.11326 79.8275 8.86686 79.1202 8.86686C78.4129 8.86686 77.8156 9.11436 77.3272 9.60826C76.8399 10.1033 76.5946 10.7347 76.5946 11.5025C76.5946 12.2703 76.8399 12.9017 77.3272 13.3967Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7028 14.8025V8.20247H84.7346L87.9422 13.3362H87.9785L87.9422 12.0646V8.20247H88.7903V14.8025H87.9048L84.5487 9.41907H84.5124L84.5487 10.6907V14.8025H83.7028Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7302 11.7697C52.7302 12.6915 52.4574 13.4252 51.9107 13.973C51.2903 14.6242 50.4807 14.9498 49.4863 14.9498C48.5337 14.9498 47.723 14.6198 47.0575 13.9598C46.3909 13.2987 46.0576 12.4803 46.0576 11.5035C46.0576 10.5256 46.3909 9.7072 47.0575 9.0472C47.723 8.3861 48.5337 8.0561 49.4863 8.0561C49.9593 8.0561 50.4114 8.1485 50.8404 8.3322C51.2705 8.517 51.6148 8.7623 51.8722 9.0692L51.2925 9.65C50.8558 9.1275 50.2541 8.8668 49.4852 8.8668C48.79 8.8668 48.1894 9.111 47.6823 9.5994C47.1752 10.0878 46.9222 10.7225 46.9222 11.5024C46.9222 12.2823 47.1752 12.917 47.6823 13.4054C48.1894 13.8938 48.79 14.138 49.4852 14.138C50.2222 14.138 50.8371 13.8927 51.3288 13.401C51.6478 13.0809 51.8326 12.6354 51.8821 12.0645H49.4852V11.2714H52.6829C52.7159 11.4441 52.7302 11.6102 52.7302 11.7697Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8013 9.01317H54.7961V11.1054H57.5065V11.8985H54.7961V13.9907H57.8013V14.8025H53.948V8.20247H57.8013V9.01317Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3773 14.8025H60.5292V9.01317H58.6856V8.20247H63.2209V9.01317H61.3773V14.8025Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5022 14.8025V8.20247H67.3502V14.8025H66.5022Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1113 14.8025H70.2632V9.01317H68.4196V8.20247H72.9549V9.01317H71.1113V14.8025Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5402 13.95C80.8912 14.6166 80.0849 14.9499 79.1202 14.9499C78.1555 14.9499 77.3492 14.6166 76.7013 13.95C76.0523 13.2834 75.7289 12.4672 75.7289 11.5025C75.7289 10.5378 76.0523 9.72155 76.7013 9.05495C77.3492 8.38835 78.1555 8.05396 79.1202 8.05396C80.0794 8.05396 80.8846 8.38945 81.5358 9.05935C82.187 9.72925 82.5126 10.5433 82.5126 11.5025C82.5126 12.4672 82.1881 13.2834 81.5402 13.95ZM77.3272 13.3967C77.8156 13.8917 78.4129 14.1381 79.1202 14.1381C79.8275 14.1381 80.4259 13.8906 80.9132 13.3967C81.4016 12.9017 81.6469 12.2703 81.6469 11.5025C81.6469 10.7347 81.4016 10.1033 80.9132 9.60826C80.4259 9.11326 79.8275 8.86686 79.1202 8.86686C78.4129 8.86686 77.8156 9.11436 77.3272 9.60826C76.8399 10.1033 76.5946 10.7347 76.5946 11.5025C76.5946 12.2703 76.8399 12.9017 77.3272 13.3967Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7028 14.8025V8.20247H84.7346L87.9422 13.3362H87.9785L87.9422 12.0646V8.20247H88.7903V14.8025H87.9048L84.5487 9.41907H84.5124L84.5487 10.6907V14.8025H83.7028Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1785_50327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.05 8.79417C11.7299 9.13297 11.5406 9.65877 11.5406 10.3397V34.6673C11.5406 35.3493 11.7299 35.874 12.05 36.2128L12.1313 36.292L25.7592 22.6641V22.5035V22.3429L12.1313 8.71387L12.05 8.79417Z",
    fill: "url(#paint0_linear_1785_50327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3012 27.2081L25.7593 22.664V22.5034V22.3428L30.3023 17.7998L30.4046 17.8581L35.7869 20.9161C37.3236 21.7895 37.3236 23.2184 35.7869 24.0929L30.4046 27.1509L30.3012 27.2081Z",
    fill: "url(#paint1_linear_1785_50327)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1785_50327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4045 27.1498L25.7581 22.5034L12.0499 36.2127C12.5559 36.7495 13.393 36.8155 14.3357 36.2809L30.4045 27.1498Z",
    fill: "url(#paint2_linear_1785_50327)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.4045 17.8571L14.3357 8.7271C13.393 8.1914 12.5559 8.2585 12.0499 8.7953L25.7592 22.5046L30.4045 17.8571Z",
    fill: "url(#paint3_linear_1785_50327)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.07031,
    y: 1.00244,
    width: 147.5,
    height: 43,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1785_50327",
    x: 11.5406,
    y: 8.35742,
    width: 25.3988,
    height: 28.2927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1785_50327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1785_50327",
    result: "effect2_innerShadow_1785_50327"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1785_50327",
    x: 12.0499,
    y: 22.5034,
    width: 18.3546,
    height: 14.1467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1785_50327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1785_50327",
    x1: 24.5512,
    y1: 10.0823,
    x2: 6.09103,
    y2: 28.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1785_50327",
    x1: 37.7872,
    y1: 22.5034,
    x2: 11.1717,
    y2: 22.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1785_50327",
    x1: 27.8812,
    y1: 25.0267,
    x2: 2.8469,
    y2: 50.0611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1785_50327",
    x1: 8.59747,
    y1: 0.696885,
    x2: 19.776,
    y2: 11.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndriodDark);
export default __webpack_public_path__ + "static/media/andriodDark.7c61cc1893d67d9f5d25a9529fc6c78f.svg";
export { ForwardRef as ReactComponent };